<template>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Registrars</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
      <table class="table-hover table" id="registrar-table">
      <thead>
      <tr>
        <th>Registrar</th>
        <th>Network</th>
        <th>Domains</th>
        <th>Expiring soon</th>
        <th>Unknown</th>
      </tr>
      </thead>
    </table>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      table: null
    }
  },
  computed: {
    ...mapGetters({
      regos: 'getRegistrars',
      viewFilters: 'getViewFilters'
    })
  },
  mixins: [Query],
  mounted () {
    this.$store.dispatch('loadRegistrars', this.buildQuery(this.viewFilters + '&domainCounts=1')).then(() => { this.drawTable() })
  },
  watch: {
    regos () {
      this.drawTable()
    },
    viewFilters () {
      console.log('view filters have changed')
      this.$store.dispatch('loadRegistrars', this.buildQuery(this.viewFilters) + '&domainCounts=1').then(() => { this.drawTable() })
    }
  },
  methods: {
    drawTable () {
      this.table = $('#registrar-table').DataTable()
      this.table.rows().remove()
      this.regos.forEach(rego => {
        this.table.row.add([
          rego.name,
          rego.client ? rego.client.name : '/',
          rego.domainCount,
          rego.expiringSoon || 0,
          rego.noExpiryDate || 0
        ])
      })
      this.table.draw(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/Registrars.vue